var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":"https://summitproedu.imgix.net/summit-education-logo.svg","alt":"Summit Professional Education"}})}
var staticRenderFns = []

export { render, staticRenderFns }